module.exports = __webpack_public_path__ + "static/scale-model-of-buffalo-place-inc-in-buffalo-new-york-94fbb88faf580547924eef11c14ed80b.png";